import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=74559d9d&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74559d9d')) {
      api.createRecord('74559d9d', component.options)
    } else {
      api.reload('74559d9d', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=74559d9d&", function () {
      api.rerender('74559d9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Xt64G4IhKZhT/JS/comp/IncreaseNumber.vue"
export default component.exports